var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading && !_vm.items.length)?_c('div',{staticClass:"empty-table-msg"},[_vm._v(" "+_vm._s(_vm.emptyTableMsg)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }